export enum AnimationStyle {
    BELL_WIGGLE = 'bell-wiggle',
}
